import "../../../../../chunk-5WRI5ZAA.js";

// src/visualBuilder/components/Collab/ThreadPopup/ContextProvider/ThreadProvider.tsx
import React from "preact/compat";
var ThreadProvider = React.createContext(null);
export { ThreadProvider };